class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

/*
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
*/
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.hoverTimer = null;
    this.setupHoverEvents();
    this.setupGlobalClickHandler();
  }

  setupHoverEvents() {
    // Mouse hover events for better UX
    this.addEventListener("mouseenter", () => {
      clearTimeout(this.hoverTimer);
      this.open();
    });

    this.addEventListener("mouseleave", () => {
      this.hoverTimer = setTimeout(() => {
        this.close();
      }, 150); // Small delay to prevent flickering
    });

    // Preserve keyboard/click functionality for accessibility
    const summary = this.mainDetailsToggle.querySelector("summary");
    summary.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = this.mainDetailsToggle.hasAttribute("open");
      isOpen ? this.close() : this.open();
    });

    // Handle keyboard navigation
    summary.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const isOpen = this.mainDetailsToggle.hasAttribute("open");
        isOpen ? this.close() : this.open();
      }
    });
  }

  setupGlobalClickHandler() {
    // Close menus when clicking outside (only set up once)
    if (!HeaderMenu.globalClickHandlerSet) {
      document.addEventListener("click", (e) => {
        if (!e.target.closest("header-menu")) {
          document.querySelectorAll("header-menu").forEach((menu) => {
            menu.close();
          });
        }
      });
      HeaderMenu.globalClickHandlerSet = true;
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", true);
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", "true");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

// Static property to track global click handler
HeaderMenu.globalClickHandlerSet = false;

customElements.define("header-menu", HeaderMenu);
